import Ajv from 'ajv'
import yaml from 'js-yaml'

import { bus, errorHandler } from '@/utils'
import helper from '@/utils/helper.js'
import imSchema from '../../../information_model/json_schema.json'

const ajv = new Ajv({
  allErrors: true
})
ajv.addSchema(imSchema, 'im')

export default {
  beforeDestroy () {
    bus.$off('add-information-modal')
  },
  computed: {
    setFieldData () {
      return {
        UploadField: {
          label: this.$t('informationModelUploadButtonUploadText'),
          model: this.data.files,
          name: 'InformationModel',
          selectedFileName: this.selectedFileName || this.$t('NoFileChosen'),
          validate: 'required'
        }
      }
    }
  },
  methods: {
    async updateInformationModels () {
      return Promise.all(this.filterFiles(this.data.files))
        .then(arr => this.validateFiles(arr))
        .then(data => this.$api.updateInfoModel(data))
        .then(() => {
          bus.$emit('get-information-model-list')
          return this.successCallback()
        })
        .catch(error => this.failedCallback(error))
    },
    alert (type, message) {
      this.alert$.type = type
      this.alert$.errors = message
      this.alert$.show = true
    },
    closePopup () {
      this.reset()
      this.alert$.show = false
      this.showModal = false
    },
    failedCallback (e) {
      this.loading = false
      if (helper.notShowAlertList.includes(e.status)) return

      let errorMessage = typeof e.status === 'number' ? errorHandler(this.component, e.status) : e

      if (typeof errorMessage === 'string') {
        errorMessage = [this.$t(errorMessage)]
      }

      if (!Array.isArray(errorMessage)) {
        errorMessage = [e.message || e.body]
      }

      this.alert('error', errorMessage)
    },
    filesChange (id, fieldName, fileList) {
      this.data.formData = new FormData()
      const fileExist = fileList && fileList.length > 0
      const field = this.fieldsData[id]

      field.selectedFileName = ''
      if (fileExist) {
        field.selectedFileName = fileList.length > 1 ? `${fileList.length} files` : fileList[0].name

        this.data.files = Object.keys(fileList).map(key => fileList[key])

        for (const key in fileList) {
          this.data.formData.append(fieldName, fileList[key], fileList[key].name)
        }
      }
    },
    filterFiles (files) {
      return files
        .filter(file => this.isValidFileType(file.type))
        .map(file => this.readFiles(file))
    },
    isJsonFile (type) {
      return type === 'application/json'
    },
    isValidFileType (type) {
      return this.isJsonFile(type) || this.isYamlFile(type) || type === ''
    },
    isYamlFile (type) {
      return type === 'application/x-yaml'
    },
    readFiles (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = () => {
          let result

          try {
            result = this.isJsonFile(file.type) ? JSON.parse(reader.result) : yaml.safeLoad(reader.result)
          } catch (error) {
            reject({ message: this.$t('informationModelUploadErrorMessageInvalidFile') })
          }
          const text = JSON.stringify(result)

          resolve({
            lastModified: file.lastModified,
            name: file.name,
            size: file.size,
            text
          })
        }

        reader.readAsText(file)
      })
    },
    reset () {
      document.getElementById('InformationModel').value = ''
      this.data = {
        files: [],
        formData: null
      }
      this.fieldsData = {}
      this.selectedFileName = ''
      this.$nextTick(() => {
        this.$validator.reset()
        this.$validator.errors.clear()
      })
    },
    save () {
      return this.$validator.validateAll()
        .then(async (result) => {
          if (result) {
            this.loading = true
            await this.updateInformationModels()
          }
        })
    },
    successCallback () {
      this.loading = false
      this.closePopup()
      this.$message({
        message: this.$t('informationModelUploadMessageUploadSuccessful'),
        showClose: true,
        type: 'success'
      })
    },
    validateFiles (array) {
      let errorMessages = []
      let allModel = array.reduce((acc, val) => {
        let model = {}

        try {
          model = JSON.parse(val.text)
        } catch (e) {
          model = yaml.safeLoad(val.text)
        }

        const valid = ajv.validate('im', model)
        if (valid) {
          acc = Object.assign(val, { familyName: model.familyName })
        } else {
          errorMessages = ajv.errors.map(({ dataPath, message }) => `${val.name}: ${dataPath} ${message}`)
          errorMessages = Array.from(new Set(errorMessages))
        }

        return acc
      }, {})
      if (errorMessages.length !== 0) {
        throw errorMessages
      }

      return allModel
    }
  },
  name: 'InformationModelUpload',
  data () {
    return {
      alert$: {
        errors: '',
        show: false,
        type: ''
      },
      component: 'informationModelUpload',
      data: {
        files: [],
        formData: null
      },
      dialogProps: {
        beforeClose: () => this.closePopup()
      },
      fieldsData: {},
      labelWidth: '150px',
      loading: false,
      selectedFileName: '',
      showModal: false
    }
  },
  mounted () {
    bus.$on('add-information-modal', (show) => {
      if (show) {
        this.showModal = true
      }

      this.fieldsData = this.setFieldData
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/InformationModelUpload/InformationModelUpload.js